export default class ApplicationCreateRequest {
	public applicationName: string;
}
